import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/Statement/tables";
import headers from "../../../../Data/Tables/Suppliers/Statement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { useParams } from "react-router-dom";
import { get_all_lpos } from "../../../../Controllers/Purchases/Lpos";
import { get_all_purchases } from "../../../../Controllers/Purchases/Orders";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../../../Reports/cairo-font";
import UserCurrency from "../../../../Componets/UserCurrency";

const SupplierOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalPurchases: 0,
    totalAmount: 0,
    overdueAmount: 0,
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const { id } = useParams();
  localStorage.setItem("Supplier_Id", id);

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      supplier: headerdata?.supplier,
      status: headerdata?.status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateTotalPaid = (purchase) => {
    if (!purchase?.payments || !Array.isArray(purchase?.payments)) return 0;
    return purchase?.payments.reduce(
      (sum, payment) => sum + (payment.amount || 0),
      0,
    );
  };

  const calculateOutstanding = (purchase, lpoData) => {
    const total = lpoData?.total || 0;
    const paid = calculateTotalPaid(purchase);
    return total - paid;
  };

  const isOverdue = (lpoData) => {
    if (!lpoData?.due_date) return false;
    return new Date(lpoData.due_date) < new Date();
  };

  const combinePurchaseData = async (lposData, purchasesData) => {
    const purchaseMap = {};
    purchasesData.forEach((purchase) => {
      purchaseMap[purchase.number] = purchase;
    });

    const combinedData = lposData.map((lpo) => {
      const purchase = purchaseMap[lpo.number];
      return {
        lpoData: lpo,
        purchaseData: purchase,
      };
    });

    return combinedData;
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        supplier: tabledata?.supplier || id,
        status: tabledata?.status,
        date: tabledata?.date,
        page: tabledata?.currentPage || 1,
        limit: 10,
        source: "Supplier-Outstanding-Statement",
      };

      const [lposResponse, purchasesResponse] = await Promise.all([
        get_all_lpos(params),
        get_all_purchases(params),
      ]);

      if (lposResponse?.status && purchasesResponse?.status) {
        const lposData = lposResponse?.data?.data || [];
        const purchasesData = purchasesResponse?.data?.data || [];

        const combinedData = await combinePurchaseData(lposData, purchasesData);

        const filteredData = combinedData.filter((item) => {
          const outstanding = calculateOutstanding(
            item.purchaseData,
            item.lpoData,
          );
          return outstanding > 0;
        });

        const startIndex = (params.page - 1) * params.limit;
        const paginatedData = filteredData.slice(
          startIndex,
          startIndex + params.limit,
        );

        let totalOutstanding = 0;
        let totalAmount = 0;
        let overdueAmount = 0;

        const tableData = paginatedData.map((item) => {
          const { lpoData, purchaseData } = item;

          const outstanding = calculateOutstanding(purchaseData, lpoData);
          const paidAmount = calculateTotalPaid(purchaseData);
          const overdue = isOverdue(lpoData);

          totalOutstanding += outstanding;
          totalAmount += lpoData.total || 0;
          if (overdue && outstanding > 0) overdueAmount += outstanding;

          const remainingAmount = (item?.total || 0) - paidAmount;

          return {
            path: `/app/purchases/lpo/view/${lpoData?._id}`,
            "PO Number": `#PO-${lpoData.number}`,
            Supplier: lpoData.supplier?.name || "N/A",
            Date: <DateTimeBadge date={lpoData?.date} />,
            "Due Date": lpoData.due_date ? (
              <DateTimeBadge date={lpoData?.due_date} />
            ) : (
              "-"
            ),
            "Total Amount": `${(lpoData.total || 0).toFixed(3)}`,
            "Paid Amount": `${paidAmount.toFixed(3)}`,
            Outstanding: `${outstanding.toFixed(3)}`,
            "Payment Status":
              purchaseData?.payment_status == 2 ? (
                <div className="flex items-center gap-3 bg-emerald-50/50 px-3 py-2 rounded-lg border border-emerald-200">
                  <span className="text-emerald-600 font-medium text-sm">
                    Paid{" "}
                  </span>
                </div>
              ) : purchaseData?.payment_status == 1 ? (
                <div className="bg-amber-50/50 p-3 rounded-lg border border-amber-200 min-w-[150px]">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-amber-700 font-medium text-sm">
                      Partial
                    </span>
                    <span className="text-xs text-gray-500">
                      {(
                        (paidAmount / (paidAmount + remainingAmount)) *
                        100
                      ).toFixed(0)}
                      %
                    </span>
                  </div>
                  <div className="space-y-1.5">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Paid</span>
                      <span className="text-emerald-600 font-semibold">
                        {paidAmount.toFixed(3)}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Remaining</span>
                      <span className="text-red-600 font-semibold">
                        {remainingAmount.toFixed(3)}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-3 bg-red-50/50 px-3 py-2 rounded-lg border border-red-200">
                  <span className="text-red-600 font-medium text-sm">
                    Unpaid
                  </span>
                </div>
              ),
            "Delivery Status":
              purchaseData?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : purchaseData?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setSummary({
          totalOutstanding,
          totalPurchases: filteredData.length,
          totalAmount,
          overdueAmount,
        });

        setPagination({
          currentPage: params.page,
          totalCount: filteredData.length,
          totalPages: Math.ceil(filteredData.length / params.limit),
        });
      } else {
        const errorMessage =
          lposResponse?.message ||
          purchasesResponse?.message ||
          "Failed to fetch supplier data";
        toast.error(errorMessage);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const fetchAllOutstanding = async () => {
    try {
      const params = {
        supplier: id,
        source: "Supplier-Outstanding-Statement",
      };

      const [lposResponse, purchasesResponse] = await Promise.all([
        get_all_lpos(params),
        get_all_purchases(params),
      ]);

      if (!(lposResponse?.status && purchasesResponse?.status)) return [];

      const lposData = lposResponse?.data?.data || [];
      const purchasesData = purchasesResponse?.data?.data || [];

      const purchaseMap = {};

      purchasesData.forEach((purchase) => {
        purchaseMap[purchase.number] = purchase;
      });

      return lposData
        .map((lpo) => {
          const purchase = purchaseMap[lpo.number];

          const paid =
            purchase?.payments?.reduce(
              (sum, item) => sum + (item.amount || 0),
              0,
            ) || 0;

          const outstanding = (lpo.total || 0) - paid;

          return {
            po: lpo.number,
            supplier: lpo?.supplier?.name || "-",
            date: lpo.date,
            dueDate: lpo.due_date,
            total: lpo.total || 0,
            paid,
            outstanding,
            paymentStatus:
              purchase?.payment_status === 2
                ? "Paid"
                : purchase?.payment_status === 1
                  ? "Partial"
                  : "Unpaid",
            deliveryStatus:
              purchase?.delivery_status === 2
                ? "Delivered"
                : purchase?.delivery_status === 1
                  ? "Partial"
                  : "Pending",
          };
        })
        .filter((item) => item.outstanding > 0);
    } catch (err) {
      toast.error("Failed to fetch data");
      return [];
    }
  };

  const downloadCSV = async () => {
    const data = await fetchAllOutstanding();

    if (!data.length) {
      toast.error("No data available");
      return;
    }

    const headers = [
      "S.No",
      "PO Number",
      "Supplier",
      "Date",
      "Due Date",
      "Total Amount",
      "Paid Amount",
      "Outstanding",
      "Payment Status",
    ];

    const csv = [
      headers.join(","),
      ...data.map((item, index) =>
        [
          index + 1,
          item.po,
          `"${item.supplier}"`,
          new Date(item.date).toLocaleDateString(),
          item.dueDate ? new Date(item.dueDate).toLocaleDateString() : "",
          item.total.toFixed(3),
          item.paid.toFixed(3),
          item.outstanding.toFixed(3),
          item.paymentStatus,
        ].join(","),
      ),
    ].join("\n");

    const blob = new Blob([new TextEncoder().encode("\uFEFF" + csv)], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");

    link.href = URL.createObjectURL(blob);
    link.download = `Supplier_Outstanding_Report_${new Date()
      .toLocaleDateString()
      .replace(/\//g, "_")}.csv`;

    link.click();
  };

  const downloadPDF = async () => {
    const data = await fetchAllOutstanding();

    if (!data.length) {
      toast.error("No data available");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    registerCairoFont(doc);

    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");
    doc.setFontSize(18);
    doc.text("Supplier Outstanding Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFontSize(10);
    doc.text(`Downloaded : ${new Date().toLocaleString()}`, pageWidth / 2, 23, {
      align: "center",
    });

    autoTable(doc, {
      startY: 30,
      head: [
        [
          "S.No",
          "PO Number",
          "Supplier",
          "Date",
          "Due Date",
          "Total",
          "Paid",
          "Outstanding",
          "Payment",
        ],
      ],
      body: data.map((item, index) => [
        index + 1,
        item.po,
        item.supplier,
        new Date(item.date).toLocaleDateString(),
        item.dueDate ? new Date(item.dueDate).toLocaleDateString() : "-",
        item.total.toFixed(3),
        item.paid.toFixed(3),
        item.outstanding.toFixed(3),
        item.paymentStatus,
      ]),
      styles: {
        font: "Cairo",
        lineWidth: 0.2,
        lineColor: [220, 220, 220],
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
      },
    });

    doc.autoPrint();

    const blob = doc.output("blob");
    window.open(URL.createObjectURL(blob));
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
    headerReset();
  }, [id]);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="flex justify-end gap-3 mt-4 mb-4">
          <Button
            type="primary"
            className="form-save-button"
            onClick={downloadCSV}
          >
            Download Excel
          </Button>

          <Button
            type="primary"
            className="form-save-button"
            onClick={downloadPDF}
          >
            Download PDF
          </Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 pt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              <UserCurrency />  {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Purchases</h3>
            <p className=" text-green-600">{summary.totalPurchases}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Amount</h3>
            <p className=" text-green-600">
              <UserCurrency />  {summary.totalAmount.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              <UserCurrency />  {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>
        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
            summary={2}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default SupplierOutstandingStatement;
